module.exports = __webpack_public_path__ + "static/media/sidedrawer_background.a7e864f1.webp";